import {Position} from '@turf/turf';

/**
 * Class permettant de gérer les Points visibles sur un plan (PCS ou PAS)
 * et pour l'impression des plans en 2D pour déterminer quel point sont actifs et
 * dans le périmètre d'impression.
 */
export class PlanEntity {

  filter: any = {};
  filterBy = [];

  show = true;
  num = '';
  coordinates: Position[][] = [];

  constructor(num: string) {
    this.num = num;
  }

  public setFilter(section: string, name: string, active: boolean, sort = 0): void {
    this.filter[section] = {
      ...this.filter[section],
      name,
      active,
      sort,
      id: `${section}-${name}`
    };

    this.filterBy.push( this.filter[section].id);
  }
}
